import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/exception.svg'


const _hoisted_1 = {
  "data-testid": "step-uploadException",
  class: "container container--slim step--upload-result step--upload-result--failed"
}
const _hoisted_2 = { class: "container__client-zone-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-80",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "exception-message" }
const _hoisted_5 = {
  class: "row",
  style: {"margin-top":"20px"}
}
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.headerOne`)), 1),
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.message`)), 1),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.uploadDocumentCount === 1)
        ? (_openBlock(), _createBlock(_component_SubmitButton, {
            key: 0,
            "data-testid": "btn-uploadException-again",
            action: _ctx.action.UPLOAD_TRY_AGAIN,
            class: "button button--submit",
            data: {}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadAgain`)), 1)
            ]),
            _: 1
          }, 8, ["action"]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        "data-testid": "btn-uploadException-skip",
        class: "button button--skip",
        "cy-data": "go-to-personal-data",
        disabled: _ctx.isSubmitting,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSkip && _ctx.handleSkip(...args)))
      }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.skipAndContinue`)) + " » ", 9, _hoisted_6)
    ])
  ]))
}